export default __webpack_public_path__ + "media/images/icons/youtube-d577836ff48954413bc27498fcc962a0.svg";